module.exports = __webpack_public_path__ + "static/img/7.226a099.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/8/1/2/eng/7.png
// module id = 3mTq
// module chunks = 0